<template>
  <v-menu
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="false"
    :close-on-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        class="ma-0"
        :disabled="disabled"
        v-on="on"
      >
        <v-icon>send</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pb-2">
        <h2 class="title font-weight-bold">
          Отправка файлов
        </h2>
      </v-card-title>
      <v-card-text class="py-0">
        <v-form>
          <v-layout column>
            <v-text-field
              v-model="email"
              label="Email"
              hide-details
              :rules="emailRules"
            />
            <v-text-field
              v-model="theme"
              label="Тема письма"
              hide-details
              :rules="themeRules"
            />

            <v-layout
              column
              class="mt-3"
            >
              <v-checkbox
                v-for="(attachment, index) in attachments"
                :key="index"
                v-model="selected"
                multiple
                hide-details
                :label="attachment.title"
                :value="attachment.id"
                class="mt-0"
              />
            </v-layout>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          flat
          color="primary"
          :disabled="!isValid"
          :loading="sendLoading"
          @click="send"
        >
          Отправить
        </v-btn>
        <v-btn
          flat
          @click="menu = false"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import * as attachmentsApi from "../../backend/attachmentsApi.js";

export default {
  props: ["disabled", "attachments", "resource"],
  data() {
    return {
      menu: false,
      theme: "",
      themeRules: [v => !!v || "Тема письма обязательна к заполнению"],
      email: "",
      emailRules: [
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || v === "" || "Некорректный e-mail.";
        },
        v => !!v || "Email обязательный к заполнению",
      ],
      selected: [],
      sendLoading: false,
    };
  },
  computed: {
    isValid() {
      return this.email && this.theme && this.selected.length > 0;
    },
  },
  methods: {
    async send() {
      this.sendLoading = true;
      await attachmentsApi.createAttachment(
        this.resource,
        this.email,
        this.theme,
        this.selected,
      );
      this.sendLoading = false;

      this.showInfo("Документы отправлены");

      this.selected = [];
      this.email = "";
      this.theme = "";

      this.menu = false;
    },
  },
};
</script>
